import { z } from "zod/v4";

import { OrganizationSummaryDtoSchema } from "../../../dtos/organization-summaries";

export const GetAdminOrganizationSummaryByIdPathParamsSchema = z.object({
  orgId: z.uuid(),
});

export type GetAdminOrganizationSummaryByIdPathParamsType = z.infer<
  typeof GetAdminOrganizationSummaryByIdPathParamsSchema
>;

export const GetAdminOrganizationSummaryByIdResponseBodySchema = z.object({
  org: OrganizationSummaryDtoSchema,
});

export type GetAdminOrganizationSummaryByIdResponseBodyType = z.infer<
  typeof GetAdminOrganizationSummaryByIdResponseBodySchema
>;
